define('controllers/myservices/pay/pay-detail.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('payDetailCtrl', ['$scope', '$q', '$filter', '$stateParams', '$state',
        'OpenApp', 'UserInfo',
        'OpenGW','auiDialog','HuaweiTrade','OpenOther','payService','getServiceList',
        function ($scope, $q, $filter, $stateParams, $state,
                  OpenApp, UserInfo,
                  OpenGW,auiDialog,HuaweiTrade,OpenOther,payService,getServiceList) {

            var prodID = $stateParams.prodID;
            var openStateFilter = mainCons.appConstant.openStateFilter;
            $scope.redirectToPms = redirectToPms;
            $scope.delete = deleteSer;
            $scope.backToList = backToList;
            var paramsQueryAppName = {
                request: {
                    appID: $stateParams.prodID
                }
            };

            var Model = $scope.Model = {
                pmsSdkLink: sysUrlCfg.documentHref.pmsSdkUrl,
                defaultList: []
            };

            init();

            function init() {

                payService.hasMerchantAuth().then(function(hasAuth){
                    $scope.hasMerchantAuth = hasAuth;
                });

                UserInfo.promise().then(function(userInfo){
                    $scope.CPID = userInfo.id;
                });

                OpenApp.getAppDetail(paramsQueryAppName).then(function (data) {
                    if (data && data.resultCode == 0) {
                        Model.currAppDetail = data.appInfo;
                        var gwParams = {
                            appId: prodID,
                            attrs: ["secret"]
                        }
                        payService.getFingerPrintInfo(data.appInfo,Model);
                        OpenGW.getAppInfo(gwParams).then(function (data) {
                            Model.appsecret = data.secret;
                        });
                    }
                });


                payService.getPayDeveloperKey({keyType: 2}).then(function(devres){
                    Model.developKey = devres.developKey;
                    Model.developPubKey = devres.developPubKey;
                    if(devres.developNewKeys){
                        Model.developNewKey = devres.developNewKeys[0].priKey;
                        Model.developNewPubKey = devres.developNewKeys[0].pubKey;
                    }
                    if(devres.huaweiPubKey){
                        Model.huaweiPubKey = devres.huaweiPubKey;
                    }

                });

                // 获取服务提交时间
                getServiceList.getWorkOrdersCreateTime(8,prodID,$scope.productList).then(function (res) {
                    Model.createTime = res;
                });

                // 获取状态、回调地址
                var params = {
                    request: {
                        prodID: [prodID]
                    }
                };
                OpenApp.getProductByID(params).then(function (data) {
                    if (data) {
                        if (data.productList[0]) {
                            $scope.product = data.productList[0];
                            data.productList[0].serviceList.forEach(function (v) {
                                if (v.serviceItem == 8) {
                                    $scope.product.serviceSingle = v;
                                }
                            });
                            //判断是显示电视支付还是移动应用支付 电视支付不显示不展示 CPID 和 浮标密钥
                            $scope.prodType = Model.prodType = data.productList[0].prodType;
                            Model.prodName = data.productList[0].prodName;
                            Model.isShowPms = Model.prodType == 1;
                            angular.forEach(data.productList[0].serviceList, function (GService) {
                                if (GService.serviceItem == 8) {
                                    Model.serviceStatus = $filter('auiMapWithDefault')(GService.openState, openStateFilter, 0);

                                    var signParams2 = {
                                        params: {
                                            content: "applicationID=" + prodID,
                                            signtype: 'HMAC',
                                            keytype: 'trade-hmacsha256'
                                        }
                                    };

                                    HuaweiTrade.sign(signParams2).then(function (data1) {
                                        var res = angular.fromJson(data1);
                                        if (res.returnCode === '0') {
                                            var qryParams = {
                                                params: {
                                                    applicationID: prodID,
                                                    signType: 'HMAC',
                                                    sign: res.sign
                                                }
                                            };
                                            HuaweiTrade.qryUserInfo(qryParams).then(function (data2) {
                                                var res2 = angular.fromJson(data2);
                                                if (res2.returnCode === '0') {
                                                    if (res2.url) {
                                                        //回调地址
                                                        Model.callbackUrl = res2.url.trim();
                                                    }

                                                    // 支付方式出场顺序
                                                    Model.payTypeList = res2.payTypeList || [];

                                                    getPayType();
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    } else {
                        auiDialog.fail("查询产品信息失败。");
                    }
                });
            }

            //删除
            function deleteSer(prod) {
                getServiceList.deleteAll(prod).then(function (res) {
                    if (res && res.resultCode == 0) {
                        auiDialog.successAndMark('删除成功', function () {
                            $state.go('myServiceList',{serviceItem:'8'},{reload:true});
                        },{isOnShelf:'4'});
                    }
                });
            }

            function getPayType(){
                // 支付方式设置
                var getPayInfoParams = {
                    langType: 'zh_cn',
                    dicName: 'sysinfor.PayTypesbyLeague'
                };

                OpenOther.getPayInfo(getPayInfoParams).then(function (data) {
                    if (data) {
                        var supportTypeList = data.dics[0].value;
                        var array = supportTypeList.split('|');

                        for (var i = 0; i < array.length; i++) {
                            var payType = {};
                            payType.key = array[i].substring(0, array[i].indexOf('-'));
                            payType.value = array[i].substring(array[i].indexOf('-') + 1, array[i].length);
                            Model.defaultList.push(payType);
                        }

                        for(var h = 0 ;h < Model.defaultList.length; h++){
                            var payType2 = Model.defaultList[h];

                            var checkedPayFlag = false;
                            //字典中存在，并且应用也存在，则单选框选中
                            for(var j = 0; j < Model.payTypeList.length; j++) {
                                if (payType2.key == Model.payTypeList[j].payType) {
                                    checkedPayFlag =true;
                                }
                            }

                            //不再支持的支付方式，单选框不选择
                            var mobileValueArr = systemParaConf.payMobile.mobileValue.split(",");
                            for (var k = 0; k < mobileValueArr.length; k++) {
                                if (mobileValueArr[k] == payType2.key) {
                                    checkedPayFlag =false;
                                }
                            }
                            payType2.checkedPayFlag = checkedPayFlag;
                            Model.defaultList[h] = payType2;
                        }
                    }
                }).catch(function (data) {
                });
            }

            function backToList() {
                $scope.queryList();
                $state.go('myServiceList',{serviceItem:'8'});
            }

            //重定向到pms
            function redirectToPms() {
                window.open("/consumer/en/service/josp/agc/index.html?cid=1&tid=13&id=1311");
            }

        }]);
});

